import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PairDetailTable from "./PairDetailTable";

// Full-screen drill-down for a single source↔destination pair, opened from
// TrafficLogsTable's "Details" button — the full log grid for that pair.
const PairDetailDialog = ({ open, pair, dateFilter, multiSecurityView, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    sx={{ "& .MuiDialog-paper": { width: "100%", height: "100%", maxWidth: "none", backgroundColor: "#1c1c1c", backgroundImage: "none" } }}
  >
    <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8, zIndex: 1, color: (t) => t.palette.grey[400] }}>
      <CloseIcon />
    </IconButton>
    <DialogContent sx={{ display: "flex", flexDirection: "column", pt: 5 }}>
      <PairDetailTable pair={pair} dateFilter={dateFilter} multiSecurityView={multiSecurityView} />
    </DialogContent>
  </Dialog>
);

export default PairDetailDialog;
